import { Injectable } from '@angular/core';
import { mergeMapTo } from 'rxjs/operators';
import { AngularFireMessaging } from '@angular/fire/messaging';

import { ADMIN_CONSTANT } from './app.model';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  private service: AppService;

  constructor(private afMessaging: AngularFireMessaging) {
    if ('PushManager' in window) {
      afMessaging.onMessage((message) => this.showNotificationToast(message));
    }
  }

  pushMessagingControl(service: AppService): void {
    this.service = service;
    if ('PushManager' in window) {
      this.afMessaging.requestPermission
        .pipe(mergeMapTo(this.afMessaging.tokenChanges))
        .subscribe(
          (token) => {
            this.setApplicationToken(token);
          },
          (error) => {
            console.log(error);
            this.setApplicationToken('PUSH_NOTIFICATION_NOT_GRANTED');
          }
        );

      this.afMessaging.messages.subscribe((message) =>
        this.showNotificationToast(message)
      );
    }
  }

  setApplicationToken(token: string): void {
    this.service.setToken(
      ADMIN_CONSTANT.ADMIN_TOKEN_PUSH_NOTIFICATION,
      'PUSH_NOTIFICATION_NOT_GRANTED',
      true
    );
    this.service.userData = {
      ...this.service.userData,
      AuthToken: token,
    };
    this.service.setToken(
      ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_USER_DATA,
      this.service.userData
    );
  }

  refreshToken(): void {
    if ('PushManager' in window) {
      this.afMessaging.requestToken.subscribe((token) =>
        this.setApplicationToken(token)
      );
    }
  }

  showNotificationToast(message: any): void {
    console.log(message);
    this.service.showToast(
      `${message.title}\n${message.body}`,
      'Dismiss',
      ADMIN_CONSTANT.TIMER_DURATION_ULTRA_HIGH
    );
  }
}
